module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var fontService = require('FontService').default;

var size = fontService.getFontSizes();
var fonts = fontService.getFonts();

var margin = '';
if (factoryKey !== 'control_table') {
    margin = 'margin-right: 14px;';
}

    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">")
    ; __append(escapeFn( gridData[selectedRowId].attributes.styleTextSectionHeader ))
    ; __append("</span></div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-8\">\r\n        <select name=\"fontFamily\" class=\"style-font\"  id=\"fontFamily\">\r\n            \r\n        </select>\r\n    </div>\r\n    <div class=\"col-md-4\" style=\"text-align: right; ")
    ; __append(escapeFn(margin))
    ; __append("\">\r\n        <select name=\"fontSize\" id=\"fontSize\" class=\"style-font\" style=\"width: 45px;\">\r\n            ")
    ;  for (var i = 0; i < size.length; i++) { 
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn(size[i]))
    ; __append("\">")
    ; __append(escapeFn(size[i]))
    ; __append("</option>\r\n            ")
    ;  }; 
    ; __append("\r\n            <option></option>\r\n        </select>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-6 subsection nopadding-r\">\r\n        <div>\r\n            <div id=\"main_text_font_family_custom\">\r\n                <input id=\"customFontFamily\" style=\"margin-bottom:2px; width:135px;\" name=\"customFontFamily\" type=\"text\" value=\"")
    ; __append(escapeFn( gridData[selectedRowId].attributes.customFontFamily ))
    ; __append("\" ")
    ; __append(escapeFn( gridData[selectedRowId].attributes.customFontFamilyDisabled ))
    ; __append("/>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"row\"> \r\n    <div class=\"col-md-8\">\r\n        <input id=\"textColorPicker\" name=\"textColorPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( gridData[selectedRowId].attributes.textColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n        <input id=\"textColor\" name=\"textColor\" type=\"text\" maxlength=\"7\" style=\"width:80px;\" value=\"")
    ; __append(escapeFn( gridData[selectedRowId].attributes.textColor ))
    ; __append("\" />\r\n    </div>\r\n    <div class=\"col-md-4\" style=\"text-align: right;\">\r\n        <img id=\"boldText\" name=\"textWeight\" title=\"Bold\" src=\"")
    ; __append( require('editor/icons/bold-23.png') )
    ; __append("\" style=\"width: 20px; height: 20px; background-color: ")
    ; __append(escapeFn( gridData[selectedRowId].attributes.boldSelection ))
    ; __append("\" />\r\n        <img id=\"italicText\" name=\"textStyle\" title=\"Italic\" src=\"")
    ; __append( require('editor/icons/italic-23.png') )
    ; __append("\" style=\"width: 20px; height: 20px; background-color: ")
    ; __append(escapeFn( gridData[selectedRowId].attributes.italicSelection ))
    ; __append("\" />\r\n    </div>\r\n</div>")
  }
  return __output;

}